import moment from 'moment'
import i18n from '@/utils/i18n'

moment.locale(i18n.locale)

export default moment
